import styles from './LogoLink.scss';

import logoImage from 'src/images/icons/clover-logo.svg';
import markImage from 'src/images/icons/clover-mark.svg';

import cx from 'classnames';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Link, LinkProps } from 'react-router-dom';
import { Image } from 'src/components/Image/Image';
import { LocaleLink } from '../ContentLink/LocaleLink';

type Props = Pick<LinkProps, Exclude<keyof LinkProps, 'to' | 'role' | 'title'>> & {
  markOnly?: boolean;
};

const LogoLink = React.forwardRef<Link, WithTranslation & Props>(({ markOnly, t, i18n, tReady, className, ...props }, ref) => (
  <LocaleLink to="/" title={t('clover')} aria-label={t('clover')} className={cx(styles.logo, className)} data-test="logo" innerRef={ref as React.Ref<HTMLAnchorElement>} {...props}>
    <Image src={markOnly ? markImage : logoImage} alt={t('clover')} />
  </LocaleLink>
));

const Translated = withTranslation()(LogoLink);

export { Translated as LogoLink };
